import React, { useEffect, useState, useRef } from "react"
import { motion } from "framer-motion"
import Div100vh from "react-div-100vh"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper.min.css"
import "swiper/components/effect-coverflow/effect-coverflow.min.css"
import "swiper/components/pagination/pagination.min.css"
import SwiperCore, { EffectCoverflow, Pagination } from "swiper/core"
import "./Favourites.css"
import shareIcon from "./share.svg"
import compareIcon from "./compare.svg"
import Compare from "./Compare"
import { useStore } from "../../components/ApartmentFinder/State/Store"
import FavouritesForm from "../../components/FavouritesForm"
import { useLocation } from "react-use"
import { io } from "socket.io-client"
import FavouriteCard2 from "../../components/FavouriteCard/FavouriteCard2"

import "../../components/ApartmentFinder/State/Store"

// install Swiper modules
SwiperCore.use([EffectCoverflow, Pagination])

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

const url = process.env.REACT_APP_MARKETING_SUITE
const role = process.env.REACT_APP_ROLE
export const numbers = { "1": "one", "2": "two", "3": "three", "4": "four" }

export default function Favourites() {
  const [showForm, setShowForm] = useState(false)

  const [showCompare, setShowCompare] = useState(false)
  const [swiper, setSwiper] = useState(null)
  const socket = useRef()

  const setShow360 = useStore(state => state.setShow360)

  const favourites = useStore(state => state.favourites)
  const apartments = useStore(state => state.apartments)
  const favouriteApartments = apartments.filter(a =>
    favourites.includes(a.PlotNumber)
  )

  useEffect(() => {}, [favourites, apartments])

  const favouritesData = favouriteApartments.map(apt => ({
    name: "slide_e",
    icon: "/assets/images/favourites/icon_apart_block_e.svg",
    floor_no: `floor ${apt.FloorLevel}`,
    apartment_no: `apartment ${apt.PlotNumber}`,
    bed_type: `${numbers[apt.Beds]} bed`,
    total_internal_area: `${apt["Sqm"]} sq m | ${apt["Sqft"]} sq ft`,
    total_external_area: `${apt["Sqm (Stage 4)"]} sq m | ${apt["Sqft (Stage 4)"]} sq ft`,
    rooms: [
      "Kitchen 4.7 x 2.1 m",
      "Living/Dining 5.5 x 4.2 m",
      "Master Bedroom 3.8 x 3.8 m",
      "Bedroom 2 4.3 x 2.9 m",
      "Bedroom 3 4.1 x 3.1 m",
      "Balcony 12 2.4 x 1.5 m"
    ]
  }))

  const setFavourites = useStore(state => state.setShare)
  const location = useLocation()

  useEffect(() => {
    const units = new URLSearchParams(location.search).get("units")
    if (units) {
      setFavourites(units.split(","))
    }
  }, [])

  useEffect(() => {
    /**
     * Make a socket connection if there is a role.
     */

    if (role) {
      socket.current = io(url)
      if (role === "recipient") {
        socket.current.on("favourites", data => {
          if (data[0] !== showCompare) {
            setShowCompare(data[0])
          } else {
            if (!data[0] && swiper) {
              try {
                swiper.slideTo(data[1])
              } catch (error) {}
            }
          }
        })
      }
    }
  }, [swiper])

  useEffect(() => {
    if (role === "sender" && swiper) {
      socket.current.emit("favourites", [showCompare, swiper.activeIndex])
    }
  }, [showCompare])

  const slideChange = e => {
    if (socket.current && role === "sender") {
      socket.current.emit("favourites", [false, e.activeIndex])
    }
  }

  return (
    <Div100vh>
      <motion.div
        className="favourites"
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
      >
        {favourites.length > 0 && (
          <Swiper
            navigation={true}
            pagination={{
              clickable: true
            }}
            scrollbar={{ draggable: true }}
            slidesPerView={"auto"}
            grabCursor={true}
            effect="coverflow"
            coverflowEffect={{
              rotate: 20,
              stretch: 0,
              depth: 20,
              modifier: 1,
              slideShadows: false
            }}
            spaceBetween={300}
            onSwiper={setSwiper}
            onSlideChange={slideChange}
            className="swiper"
          >
            {favouriteApartments.map((fav, index) => (
              <SwiperSlide key={index}>
                {apartments && (
                  <div
                    style={{
                      position: "absolute",
                      height: "44vw",
                      width: "70vw"
                    }}
                  >
                    <FavouriteCard2
                      id={fav.PlotNumber}
                      flatType={fav.PlotNumber}
                      beds={fav.Beds}
                      floor={fav.PlotNumberPlanning.split(".")[1]}
                      block={fav.PlotNumberPlanning.split(".")[0]}
                      setShow360={setShow360}
                    />
                  </div>
                )}
                {/* <FavouriteCard data={fav} /> */}
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        {favourites.length === 0 && (
          <div className="no-data">No Favourites Currently Selected</div>
        )}
      </motion.div>
      {showForm && <FavouritesForm setShowForm={setShowForm} />}
      {showCompare && (
        <Compare favouritesData={favouritesData} setShow={setShowCompare} />
      )}
      <div className="favourites-buttons">
        <img
          src={compareIcon}
          alt="Compare"
          onClick={() => setShowCompare(true)}
        />
        <img src={shareIcon} alt="Share" onClick={() => setShowForm(true)} />
      </div>
    </Div100vh>
  )
}
